import Api from 'services/api'

import { readRouteLoanNumber } from './getLoanDisplayNo'

export function setLoanNumber(defaultLoanNumber: number = 0) {
  if (defaultLoanNumber) {
    Api.setLoanNumber(`${defaultLoanNumber}`)
    return defaultLoanNumber
  }

  const loanNumber = readRouteLoanNumber()
  if (!loanNumber) return 0

  Api.setLoanNumber(loanNumber)
  return Number(loanNumber)
}

export function setBorrowerSeparator(borrowerSeparator: string) {
  Api.setBorrowerSeparator(borrowerSeparator)
}
